import { COMMON_ERR_NO_PERMISSION } from "@constants";
import { handleShowToastError } from "@utils/helpers";
import { Tabs, Typography } from "antd";
import { Content } from "antd/lib/layout/layout";
import { t } from "i18next";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { adminPaths } from "routers/routes";
import { DataTab } from "./components/DataTab";
import { ETabName } from "./constants";
import { MasterDataPageWrapper } from "./MasterDataPageStyled";
import { USER_ROLE } from "@utils/constants";
import { useCurrentUserRole } from "@hooks";

function MasterDataPage() {
  const [tabName, setTabName] = useState("company");
  const currentUserRole = useCurrentUserRole();

  const listTabs = [
    {
      label: t("V_SHOT006.TAB_COMPANY"),
      key: ETabName.COMPANY,
      children: <DataTab tabName={tabName} />,
    },
    {
      label: t("V_SHOT006.TAB_AREA"),
      key: ETabName.AREA,
      children: <DataTab tabName={tabName} />,
    },
    {
      label: t("V_SHOT006.TAB_STORE"),
      key: ETabName.STORE,
      children: <DataTab tabName={tabName} />,
    },
    {
      label: t("V_SHOT006.TAB_USER"),
      key: ETabName.USER,
      children: <DataTab tabName={tabName} />,
    },
  ];

  const handleRedirectUser = () => {
    handleShowToastError(COMMON_ERR_NO_PERMISSION, t("V_SHOT006.TITLE"));
    return <Navigate to={adminPaths.fixedAssetLedger} />;
  };

  return (
    <>
      {currentUserRole === USER_ROLE.STORE_OWNER ? (
        handleRedirectUser()
      ) : (
        <MasterDataPageWrapper>
          <Content className="master-data-header">
            <Typography className="master-data-header_title">
              {t("PC_011.TITLE")}
            </Typography>
          </Content>
          <div className="master-data_tab">
            <Tabs
              onTabClick={(key) => setTabName(key)}
              type="card"
              items={listTabs}
            />
          </div>
        </MasterDataPageWrapper>
      )}
    </>
  );
}

export { MasterDataPage };
